// Referral bonus amounts, shared by the landing-page referral UI and the
// /api/process-referrals cron so the promised and granted numbers can never
// drift apart. Bonuses are granted to BOTH inviter and invitee, but only
// after the invitee becomes a paid customer.
export const REFERRAL_BONUS_WORDS = 50000;
export const REFERRAL_BONUS_IMAGES = 150;

// Boosted bonus when the invitee subscribes to Unlimited or a higher plan.
export const PREMIUM_REFERRAL_BONUS_WORDS = 100000;
export const PREMIUM_REFERRAL_BONUS_IMAGES = 300;

// Explicit list rather than a rule derived from price or quota, so plan-lineup
// changes never silently alter referral payouts (same rationale as
// PROFESSIONAL_VOICE_CLONE_PLANS in utils/voices.ts). "Unlimited 50" is a
// cheaper tier than "Unlimited" and deliberately stays on the standard bonus.
export const PREMIUM_REFERRAL_PLANS = new Set<string>([
  'Unlimited',
  'Unlimited 200',
  'Unlimited 350',
  'Unlimited 500',
  'Unlimited 1000',
  'Unlimited 2000',
  'Unlimited 5000',
  'Teams',
  'Teams 5 seats',
  'Teams 6 seats',
  'Teams 10 seats',
  'Teams 20 seats',
  'Teams 30 seats',
  'Teams 40 seats',
  'Teams 200',
  'Teams 300',
  'Enterprise',
]);

export interface ReferralBonusAmounts {
  words: number;
  images: number;
  premium: boolean;
}

// UI helper: the bonus a referred visitor would earn for a given plan.
// Returns null for Free (the bonus requires a paid subscription).
export const getReferralBonusForPlan = (
  planName?: string | null,
): ReferralBonusAmounts | null => {
  if (!planName || planName === 'Free') return null;

  if (PREMIUM_REFERRAL_PLANS.has(planName)) {
    return {
      words: PREMIUM_REFERRAL_BONUS_WORDS,
      images: PREMIUM_REFERRAL_BONUS_IMAGES,
      premium: true,
    };
  }

  return {
    words: REFERRAL_BONUS_WORDS,
    images: REFERRAL_BONUS_IMAGES,
    premium: false,
  };
};
